/* eslint-disable no-unused-vars */
import React, { useRef, useState } from 'react';
import Dropzone from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import LoadingCircle from 'components/ui/LoadingCircle';
import { sluggify } from 'utils/localization/utils';
import DocumentUpload from './DocumentUpload';
import { ACCEPTED_FILE_TYPES } from '../../../../config/accepted-file-types';
import { useHandleDeleteDocuments, useHandleUploadDocuments, } from '../../../../utils/DocumentsHooks';
import { DELIVERY_ORDER } from '../../../../config/documents';
import { getFilesWithContentType } from 'utils/files/files';
export function BookingDeliveryOrder({ onUpload, onUploadFailed, onDelete }) {
    const [deliveryOrderDocument, setDeliveryOrderDocument] = useState(null);
    const dropzoneRef = useRef(null);
    const { t } = useTranslation();
    const handleDrop = async (files) => {
        const filesWithContentType = getFilesWithContentType(files);
        return handleUpload(filesWithContentType.map((file) => new File([file], DELIVERY_ORDER.name, Object.assign(Object.assign({}, file.options), { type: file.type }))), DELIVERY_ORDER.value);
    };
    const { uploading, handleUpload } = useHandleUploadDocuments(null, null, async (shipment, stop, type, uploadedData, userVisibility) => {
        const document = uploadedData && uploadedData.length > 0 ? uploadedData[0] : null;
        setDeliveryOrderDocument(document);
        return onUpload === null || onUpload === void 0 ? void 0 : onUpload(document);
    }, (shipment, stop, e) => {
        console.log(e);
        return onUploadFailed === null || onUploadFailed === void 0 ? void 0 : onUploadFailed(e);
    });
    const { handleDelete } = useHandleDeleteDocuments((documents) => {
        setDeliveryOrderDocument(null);
        onDelete === null || onDelete === void 0 ? void 0 : onDelete(documents);
    });
    return (React.createElement("div", { className: "" },
        React.createElement("h3", { className: "my-0 mb-4" }, t('DELIVERY_ORDER')),
        uploading && React.createElement(LoadingCircle, { text: t('PROCESSING_FILES') }),
        deliveryOrderDocument && (React.createElement(DocumentUpload, { className: "mb-4", filename: deliveryOrderDocument.name, name: t(sluggify(deliveryOrderDocument.name)), onDelete: () => handleDelete([deliveryOrderDocument]) })),
        React.createElement("button", { className: "text-sm text-blue-500 p-2", disabled: uploading, onClick: () => { var _a; return (_a = dropzoneRef.current) === null || _a === void 0 ? void 0 : _a.open(); } }, t('UPLOAD_DELIVERY_ORDER')),
        React.createElement(Dropzone, { style: { display: 'none' }, ref: dropzoneRef, onDrop: handleDrop, accept: ACCEPTED_FILE_TYPES, multiple: false }, "\u00A0")));
}
